import React from "react";


const AddIcon = props => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <g id="Group_133" data-name="Group 133" transform="translate(-1325.5 -212.5)">
                <line id="Line_77" data-name="Line 77" y1="18" transform="translate(1343.5 221.5) rotate(90)" fill="none" stroke="#fff" stroke-width="2" />
                <line id="Line_78" data-name="Line 78" y1="18" transform="translate(1334.5 212.5)" fill="none" stroke="#fff" stroke-width="2" />
            </g>
        </svg>
    );

}

export default AddIcon;